import React from "react";
import {
  ServiceOverlay,
  ServiceBannerContainer,
  ServiceBannerImage,
  ServiceBannerContent,
  ServiceBannerTitle,
  ServiceBannerText,
  ServiceBannerNote
} from "../styles/StyledComponents";

const ServiceTransferBanner = () => {
  return (
    <ServiceOverlay className="service-overlay">
      <ServiceBannerContainer>
        <ServiceBannerImage 
          src="/images/banar.jpg" 
          alt="إعلان نقل الخدمة"
        />
      </ServiceBannerContainer>
    </ServiceOverlay>
  );
};

export default ServiceTransferBanner;
